<form class="form-wrap" role="form" [formGroup]="form" (ngSubmit)="submit()">
  <dgx-modal
    [isSubmitDisabled]="!(this.form.valid && this.form.dirty)"
    [isSubmitPending]="submitting"
    [submitButtonText]="i18n.Core_Save"
    submitButtonType="primary"
    [useDefaultForm]="false"
    [canCancel]="true"
    [modalHeaderTitle]="i18n.dgFlexRow_EditSectionDetails"
    (dismiss)="onDismiss()"
    headerWrapperClasses="guts-p-h-2"
    bodyClasses="guts-p-h-2"
  >
    <ng-container class="modal-body">
      <df-local-notification
        class="block guts-m-b-2"
        [type]="NotificationType.warning"
        [text]="i18n.OrgPlans_CustomTitlesAndDescriptionsNotLocalized"
        size="small"
      ></df-local-notification>
      <df-form-root
        [form]="form"
        [model]="model"
        [options]="options"
        [fields]="fields"
      ></df-form-root>
    </ng-container>
  </dgx-modal>

  <!-- wrapping this template with parent form so we can use FormControlName with it -->
  <ng-template #markdown let-formControl="formControl" let-params="params">
    <dgx-markdown-editor
      name="editRowDescription"
      [placeholder]="i18n.dgFlexRow_TextTitlePlaceholder"
      [enableImageUpload]="false"
      [textareaId]="'editRowDescription'"
      [textareaLabel]="'editRowDescription'"
      [required]="params.required"
      [showValidationErrors]="false"
      formControlName="description"
      [maxLength]="2000"
      minHeight="150px"
      data-dgat="editSectionSettingsModal-e10"
      ngDefaultControl
    ></dgx-markdown-editor>
  </ng-template>
</form>

<ng-template let-formControl="formControl" #displayType>
  <fieldset>
    <legend class="form__label">
      {{ i18n.dgFlexRow_EditSectionDisplayOptions }}
    </legend>

    <div
      class="selection-box"
      *ngFor="let option of displayOptions; let last = last"
      [class.guts-m-b-0]="last"
      data-dgat="edit-row-details-modal-35e"
    >
      <label class="l_flexbar selection-box__label">
        <input
          id="{{ option.displayType }}"
          type="radio"
          class="selection-box__radio"
          name="displayType"
          [(ngModel)]="model.displayType"
          [value]="option.displayType"
          (change)="onDisplayTypeChange(formControl, option)"
          [checked]="true"
          required
          data-dgat="editSectionSettingsModal-b39"
        />
        <div class="guts-p-l-1">
          <div class="selection-box__text par--small">
            {{ option.displayName }}
          </div>
          <div class="selection-box__text par--small color-ebony-a61">
            {{ option.description }}
          </div>
        </div>
      </label>
    </div>
  </fieldset>
</ng-template>

<ng-template #removeButton>
  <button
    df-button
    dfButtonType="destructive"
    class="full-width"
    type="button"
    (click)="onRemoveRow()"
    data-dgat="free-text-row-modal-fa5"
  >
    {{ i18n.dgFlexRow_DeleteConfirmSubmit }}
  </button>
</ng-template>
